import * as React from 'react';
import { Link } from "react-router-dom";

export interface IWebshopShoppingCartProps {
  totalCartCount : number;
  shoppingCartUrl: string;
}

export const WebshopShoppingCart = (props: IWebshopShoppingCartProps) => {
  return <Link to={props.shoppingCartUrl} className="btn btn-primary webshop-page__shopping-cart-button">
    <span className="icon icon-shopping-cart"></span>
    {props.totalCartCount > 0 && <span className="webshop-page__shopping-cart-badge">{props.totalCartCount}</span>}
  </Link>;
};